import { formValueSelector } from 'redux-form';

const selector = formValueSelector('SamlConfiguration');

export const isFirstSectionStatusComplete = (state) => {
  const idpName = !!selector(state, 'idp.idpName');
  const idpThemeColor = !!selector(state, 'idp.idpThemeColor');
  const isFirstStatusComplete = idpName && idpThemeColor;

  return isFirstStatusComplete;
};

export const isSecondSectionStatusComplete = (state) => {
  const idpURL = !!selector(state, 'idpURL');
  const idpCertificate = !!selector(state, 'idpCertificate');
  const isSecondStatusComplete = idpURL && idpCertificate;

  return isSecondStatusComplete;
};

export const isThirdSectionStatusComplete = (state) => {
  const createUsers = selector(state, 'idp.createUsers') !== undefined;
  const updateUsers = selector(state, 'idp.updateUsers') !== undefined;
  const isLastPage = state.wizard.getIn(['SamlConfiguration', 'page']) >= 2;

  const isThirdStatusComplete = createUsers || updateUsers || isLastPage;

  return isThirdStatusComplete;
};
